module.exports = __webpack_public_path__ + "6b200fbe4c2b1cc70cbea7be7117eab3.svg";